<template>
  <div>
    <v-col offset-md="3" :md="6">
      <div v-if="numPoolInvites > 0">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header color="primary">
              You have {{ numPoolInvites }} pool Invitation(s)
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(invite, index) in poolInvites" :key="index">
              <v-row class="my-2">
                {{invite.userFName}} {{invite.userLName}} invited you to {{ invite.poolName }}
                <v-spacer></v-spacer>
                <v-icon class="mx-2" @click="accept(index)" color="primary">mdi-check-circle</v-icon>
                <v-icon class="mx-2" @click="decline(index)" color="red">mdi-close-circle</v-icon>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: "invites",
  computed: {
    ...mapGetters([
      'poolInvites', 'numPoolInvites'
    ])
  },
  created: function() {
    this.$store.dispatch('getPoolInvites')
  },
  methods: {
    updInvite(index, iStatus) {
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token}
      let obj = {
        poolId: this.poolInvites[index].poolId,
        inviteStatus: iStatus
      }
      axios.post('/api/poolInvite/update', JSON.stringify(obj), { headers: header})
      .then(() => {
        this.$store.dispatch('getPoolInvites')
        this.$store.dispatch('getMemberPools')
      })
      .catch(function(err) {
        return alert(err.response.data.err)
      })
    },
    accept(index) {
      this.updInvite(index, 'A')
    },
    decline(index) {
      let reply = confirm("Click on OK if you really want to decline this invite?")
      if (reply) {
        this.updInvite(index, 'D')
      }
    }
  }
}
</script>